import FormPage from './formPage';
import FieldSelect from './fields/fieldSelect';
import SelectVehiculeAuto from './selectVehiculeAuto'
import FieldDate from './fields/fieldDate';
import FieldYesNo from './fields/fieldYesNo';

export default class FrontVehiculeAuto extends FormPage {
    constructor(props) {
        super(props);
        this.title = 'Votre véhicule'
    }

    next() {
        this.props.setPage('vous')
    }

    back() {
        this.props.setPage('vehicule')
    }

    doRender(container) {
        return <>
            <div className="contentvbox extrabottom">
            <h1 className="top_title">Votre véhicule</h1>

            <SelectVehiculeAuto container={container} />

            <FieldDate field="date_mise_en_circulation" container={container}/>
            <FieldDate field="date_acquisition" container={container}/>
            <FieldSelect field="usage_auto" container={container}/>
            <FieldSelect field="mode_garage" container={container}/>
            <FieldYesNo field="carte_grise_france" container={container} />
            <FieldSelect field="carte_grise_titulaire" container={container}/>
            <FieldSelect field="mode_acquisition" container={container}/>
            </div>
        </>
    }
}
